<template>
  <div class="newsCard">
    <div class="newsCard-img" v-if="data.Picture">
      <img :src="data.Picture" alt />
    </div>
    <div class="newsCard-content">
      <div class="newsCard-content-left">
        <div class="newsCard-date">
          <div class="newsCard-date-month">
            <div class="day">{{ day }}</div>
            <div class="month">{{ month }}</div>
          </div>
          <div class="newsCard-date-year">{{ year }}</div>
        </div>
        <div class="newsCard-tag" v-if="data.Categories && data.Categories.length > 0">
          <div
            class="eventCard-detail-tag"
            v-if="data.Categories[0] === 3"
          >
            國際訊息
          </div>
          <div
            class="eventCard-detail-tag orange"
            v-else-if="data.Categories[0] === 2"
          >
            最新消息
          </div>
          <div
            class="eventCard-detail-tag orange"
            v-else-if="data.Categories[0] === 1"
          >
            學會公告
          </div>
              <div
                class="eventCard-detail-tag orange"
                v-else
              >
                其他
              </div>
        </div>
      </div>
      <div class="newsCard-content-right">
        <div class="newsCard-content-title">{{ data.Title }}</div>
        <div class="newsCard-content-detail" v-if="data.Id !== 'ability'">
          <a href="#" @click.prevent="goDetail(data.Id)">查看詳情</a>
        </div>
        <div class="newsCard-content-info" v-if="displayInfo" v-html="data.Content">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    from: {
      type: String,
    },
  },
  data() {
    return {
      displayInfo: false,
    };
  },
  methods: {
    goDetail(id) {
      const vm = this;
      if (vm.from === 'news') {
        vm.$router.push(`/news/${id}`);
      } else if (vm.from === 'ability') {
        vm.displayInfo = !vm.displayInfo;
      }
    },
  },
  computed: {
    day() {
      const vm = this;
      const tmpDay = vm.$moment(vm.data.CreatedOn).format('DD'); // vm.data.StartOn.split('-');
      return tmpDay;
    },
    month() {
      const vm = this;
      let tmpMonth = vm.$moment(vm.data.CreatedOn).format('MM'); // vm.data.StartOn.split('-');
      switch (tmpMonth) {
        case '01':
          tmpMonth = 'JAN';
          break;
        case '02':
          tmpMonth = 'FEB';
          break;
        case '03':
          tmpMonth = 'MAR';
          break;
        case '04':
          tmpMonth = 'APR';
          break;
        case '05':
          tmpMonth = 'MAY';
          break;
        case '06':
          tmpMonth = 'JUN';
          break;
        case '07':
          tmpMonth = 'JUL';
          break;
        case '08':
          tmpMonth = 'AUG';
          break;
        case '09':
          tmpMonth = 'SEP';
          break;
        case '10':
          tmpMonth = 'OCT';
          break;
        case '11':
          tmpMonth = 'NOV';
          break;
        case '12':
          tmpMonth = 'DEC';
          break;

        default:
          break;
      }
      return tmpMonth;
    },
    year() {
      const vm = this;
      const tmpYear = vm.$moment(vm.data.CreatedOn).format('YYYY');// vm.data.StartOn.split('-');
      return tmpYear;
    },
  },
};
</script>

<style lang="scss">
.newsCard {
  border: 1px solid #e3e3e3;
  margin-bottom: 1.25rem;
}

.newsCard-img {
  img {
    width: 100%;
    display: block;
    object-fit: cover;
    max-height: 300px;
  }
}

.newsCard-content {
  display: flex;
  align-items: center;

  @media (max-width: 420px) {
    flex-direction: column;
  }
}

.newsCard-content-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 1rem;
  @media (max-width: 420px) {
    padding-left: 0;
  }
}

.newsCard-date {
  display: flex;
  align-items: center;
  color: #001139;
  transition: all 0.5s;
  padding: 1rem;
}

.newsCard-date-month {
  .day {
    font-size: 2.25rem;
    line-height: 1;
  }

  .month {
    font-size: 1.25rem;
  }
}

.newsCard-date-year {
  writing-mode: vertical-lr;
  font-size: 1.5rem;

  // @media (max-width: 1024px) {
  //   margin-right: 1rem;
  // }
}

.newsCard-tag {
}

.newsCard-content-right {
  padding: 0 1rem;
  width: 100%;
}

.newsCard-content-title {
  font-size: 1.5rem;
  color: #313131;
  padding: 0.5rem 3rem 0 0;

  @media (max-width: 420px) {
    padding: 0;
  }
}

.newsCard-content-detail {
  text-align: right;
  // margin-top: -10px;

  a {
    position: relative;
    overflow: hidden;
    padding-right: 2rem;
    padding-bottom: 1rem;
    display: inline-block;
    color: #001139;
    font-size: 1.125rem;

    &:hover {
      text-decoration: none;

      &:before {
        right: -110%;
        transition: 0.2s;
      }

      &:after {
        right: 0%;
        transition: 0.5s;
      }
    }

    &:before {
      content: "";
      position: absolute;
      bottom: 15px;
      right: 0%;
      display: block;
      background: url("/static/arrow.png") no-repeat;
      width: 112px;
      height: 16px;
      transition: 1s;
    }

    &:after {
      content: "";
      position: absolute;
      bottom: 15px;
      right: 100%;
      display: block;
      background: url("/static/arrow.png") no-repeat;
      width: 112px;
      height: 16px;
      transition: 0.5s;
    }
  }
}
</style>
